import { Outlet, useLocation, matchPath } from "react-router-dom";
import Breadcrumbs from "../Breadcrumbs";
import Header from "../Header";
import Footer from "../Footer";
import Modal from "../Modal";
import { useEffect, useState } from "react";
import { ROUTES } from "../../../routes/AppRouterConfig";
import useMobile from "../../../hooks/useMobile";

const PageLayout = () => {
  const isMobile = useMobile();

  const [pageTitle, setPageTitle] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState(null);

  const location = useLocation();
  const currentPath = location.pathname;

  const handleModal = (value, content = null) => {
    setShowModal(value);
    setModalContent(content);
  };

  useEffect(() => {
    setPageTitle(() => {
      // Проверяем, является ли путь страницей деталей продукта (products/:categoryId/:seriesName)
      const pathWords = currentPath.split("/").filter(Boolean);
      const isProductsDetails =
        pathWords.length === 3 &&
        pathWords[0] === "products" &&
        pathWords[1] !== undefined &&
        pathWords[2] !== undefined;

      // Для страницы деталей продукта показываем title только если pageTitle установлен и не равен categoryName
      if (isProductsDetails) {
        if (
          location.state?.pageTitle &&
          location.state.pageTitle !== location.state?.categoryName
        ) {
          return location.state.pageTitle;
        }
        // Если pageTitle еще не установлен или равен categoryName, возвращаем пустую строку
        return "";
      }

      // Проверяем наличие динамического title в location.state
      if (location.state?.pageTitle) {
        return location.state.pageTitle;
      }

      // Для всех разделов документации всегда показываем "Документация"
      if (currentPath.startsWith("/documents")) {
        return ROUTES.Documentation.name;
      }

      for (const routeKey in ROUTES) {
        const route = ROUTES[routeKey];
        const match = matchPath(route.path, currentPath);

        if (match) {
          return route.name;
        }
      }
      // Если ни один маршрут не совпал
      return "";
    });
  }, [currentPath, location.state]);

  return (
    <div className="page">
      <Header handleModal={handleModal} />
      <div className="page-content">
        {currentPath !== "/" && (
          <div className="page-content_top page-width">
            <Breadcrumbs />
            <h1>{pageTitle}</h1>
          </div>
        )}

        <Outlet context={{ isMobile, handleModal, setModalContent }} />

        <Modal isOpen={showModal} handleModal={handleModal}>
          {modalContent}
        </Modal>
      </div>
      <Footer />
    </div>
  );
};

export default PageLayout;
